module.exports = {

  isArray: function(value) {
    if (Array.isArray) {
      return Array.isArray(value);
    }
    // fallback for older browsers like  IE 8
    return Object.prototype.toString.call( value ) === '[object Array]';
  }

};



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/xml-js@1.6.11/~/xml-js/lib/array-helper.js
// module id = 205
// module chunks = 0